import { ReactNode } from "react";
import { cx } from "shared/utils";

const TimeLineBullet = (props: { classNames?: string }) => {
  return (
    <div
      className={cx(
        "h-[9px] w-[9px] translate-x-[-13px] rounded-full bg-[#E8E8E9]",
        props.classNames
      )}
    />
  );
};

export const TimeLine = (props: {
  wrapperClassName?: string;
  children: ReactNode;
}) => {
  return (
    <div
      className={cx(
        "border-l border-dashed",
        props.wrapperClassName || "ml-2 border-alpha-100 pl-2 pt-1"
      )}
    >
      <ul>{props.children}</ul>
    </div>
  );
};

export const TimeLineItem = (props: {
  bullet?: ReactNode;
  children: ReactNode;
  isLast?: boolean;
  wrapperClassName?: string;
  childrenClassName?: string;
}) => {
  return (
    <li className={cx("flex", props.wrapperClassName)}>
      {props.bullet ? props.bullet : <TimeLineBullet />}
      <div className={props.childrenClassName}> {props.children}</div>
    </li>
  );
};
